// Helpers para trabajar con el catálogo de puestos de la empresa.
// Normaliza nombres (trim + lowercase) para tolerar pequeñas diferencias de
// data entre el catálogo (empresa.puestos) y el valor guardado en el empleado
// (por ejemplo si el puesto fue renombrado o si se guardó con espacios).

export function normalizePuesto(s) {
  return (s == null ? "" : String(s)).trim().toLowerCase();
}

// Construye un Map<nombre-normalizado, no_horas_extras:boolean> a partir de
// empresa.puestos. Ignora entradas sin nombre.
export function buildPuestosMap(empresa) {
  const lista = (empresa && Array.isArray(empresa.puestos)) ? empresa.puestos : [];
  const m = new Map();
  for (const p of lista) {
    const key = normalizePuesto(p?.nombre);
    if (!key) continue;
    m.set(key, !!p?.no_horas_extras);
  }
  return m;
}

// Retorna true si el puesto del empleado está configurado como "sin horas
// extras" (jefatura / confianza, Art. 143 CT).
export function puestoNoHorasExtras(puestosMap, puestoNombre) {
  return puestosMap.get(normalizePuesto(puestoNombre)) === true;
}
